import { render, staticRenderFns } from "./pendingSeller.vue?vue&type=template&id=4532fea7&scoped=true"
import script from "./pendingSeller.vue?vue&type=script&lang=js"
export * from "./pendingSeller.vue?vue&type=script&lang=js"
import style0 from "./pendingSeller.vue?vue&type=style&index=0&id=4532fea7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4532fea7",
  null
  
)

export default component.exports